import axios from 'axios';

export default {
    list:(data)=>{
        return axios.post('sugerencias/clientes', data);
    },
    companies:()=>{
        return axios.get('catalogos/categorias');
    },
    getContactsList(){
        return axios.get('clientes/listado')
    },
    getCompaniesList(){
        return axios.get('empresas/listado')
    },
    getCountriesList(){
        return axios.get('catalogos/paises')
    },
    createNewCompany(data){
        return axios.post('empresas/crear', data);
    },
    createNewContact(data){
        return axios.post('clientes/crear', data);
    },  
    deleteContact(contactId){
        return axios.delete('clientes/borrar/' + contactId);
    },  
    deleteCompany(companyId){
        return axios.delete('empresas/borrar/' + companyId);
    },
    duplicateCompany(companyId){
        return axios.get('empresas/duplicar/' + companyId);
    },  
    duplicateContact(contactId){
        return axios.get('clientes/duplicar/' + contactId);
    },
    getContactDetail(contactId){
        return axios.get('clientes/detalle/' + contactId);
    },
    updateContact(contactId, data){
        return axios.post('clientes/actualizar/'+ contactId, data);
    },
    getCompanyDetail(companyId){
        return axios.get('empresas/detalle/' + companyId);
    },
    updateCompany(companyId, data){
        return axios.post('empresas/actualizar/'+ companyId, data);
    },
    /* Seccion de configuracion de SMTP */
    getMailSendConfiguration(){
        return axios.get('detalles/envio/correo');
    },
    setMailConfiguration(data){
        return axios.post('guardar/configuracion/correos', data);
    },
    setMailSpfConfiguration(data){
        return axios.post('guardar/configuracion/spf', data);
    },
    getCompanyQuotationsList(companyId){
        return axios.get('empresas/cotizaciones/' + companyId);
    },
    getInvitationInformation(data){
        return axios.post('equipo/detalles/token', data);
    },
    userAcceptInvitation(data){
        return axios.post('aceptar/invitacion', data);
    },
    companiesBulkActions(data){
        return axios.post('empresas/acciones/lotes', data);
    },
    clientsBulkActions(data){
        return axios.post('clientes/acciones/lotes', data);
    },
    testSPF(){
        return axios.get('probar/spf');
    }
    
}